import { Navigate } from 'react-router-dom';

import { checkPermission, AllPermissionRequired, AnyOnePermissionRequired } from 'shared/util/permission';

interface Props1 extends AllPermissionRequired {
	permission: string[];
	component: any;
}

interface Props2 extends AnyOnePermissionRequired {
	anyOnePermission: string[];
	component: any;
}

/**
 * RouteManager - render routes based on permissions
 * @param permission : number of ALL permissions to check before rendering
 * @param anyOnePermission : number of ANY OF GIVEN permissions to check before rendering
 * @param path : router parameter : path
 * @param exact : router parameter : exact
 * @param component : router parameter : component
 */
const RouteManager = (props: Props1 | Props2) => {
	const doesHavePermission = checkPermission({
		permission: (props as Props1).permission,
		anyOnePermission: (props as Props2).anyOnePermission
	});
	if (!doesHavePermission) {
		// if user does not have permission, redirect to 404
		return <Navigate to="/404" />;
	}
	return props.component;
};

export default RouteManager;
